import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LanguageId } from 'src/app/_models/language-id.enum';

/**
 * The page every unmatched URL lands on.
 *
 * Two different people reach it and it assumes nothing about either: an employee following a
 * stale link inside the app, and a guest whose scanned QR URL arrived without its token. So it
 * renders on its own, outside the authenticated shell, and needs no session to say anything
 * useful.
 */
@Component({
  selector: 'not-found',
  templateUrl: 'not-found.component.html',
  styleUrls: ['not-found.component.css'],
  standalone: false
})
export class NotFoundComponent implements OnInit {
  constructor(
    private location: Location,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    // A guest has no profile to read a language from, and nothing on this route has set one.
    // A signed-in user already has theirs — including sv and pl, which the two-way fallback
    // here cannot express — so an active language is left alone.
    if (!this.translate.currentLang()) {
      this.translate.use(Number(localStorage.getItem('languageId')) === LanguageId.English ? 'en' : 'no');
    }
  }

  /**
   * Back to wherever they came from. A URL opened directly — typed, or scanned off a wall —
   * has nothing to go back to, which is why the page reads as a destination on its own rather
   * than relying on this.
   */
  goBack(): void {
    this.location.back();
  }
}
